var _path, _path2, _g, _path3, _path4, _g2, _path5, _g3, _path6, _path7, _g4, _path8, _g5, _path9, _path10, _g6, _path11, _path12, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1728)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0962 11.0962C13.6346 8.55779 13.6346 4.44221 11.0962 1.90381C8.55779 -0.634602 4.44222 -0.634602 1.90381 1.90381C-0.634597 4.44221 -0.634597 8.55779 1.90381 11.0962C4.44222 13.6346 8.55779 13.6346 11.0962 11.0962Z",
    fill: "#FFE44E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0962 11.0962C13.6346 8.55779 13.6346 4.44221 11.0962 1.90381C8.55779 -0.634602 4.44222 -0.634602 1.90381 1.90381C-0.634597 4.44221 -0.634597 8.55779 1.90381 11.0962C4.44222 13.6346 8.55779 13.6346 11.0962 11.0962Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8697 39.2965C50.0748 30.0914 50.0748 15.167 40.8697 5.9619C31.6646 -3.2432 16.7401 -3.2432 7.53505 5.9619C-1.67005 15.167 -1.67005 30.0914 7.53505 39.2965C16.7402 48.5016 31.6646 48.5016 40.8697 39.2965Z",
    fill: "#FFD635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1084 3.20805L2.91351 14.5165L3.45619 15.1017L15.6511 3.79326L15.1084 3.20805Z",
    fill: "#FFF09C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0962 11.0962C13.6346 8.55779 13.6346 4.44221 11.0962 1.90381C8.55779 -0.634602 4.44222 -0.634602 1.90381 1.90381C-0.634597 4.44221 -0.634597 8.55779 1.90381 11.0962C4.44222 13.6346 8.55779 13.6346 11.0962 11.0962Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_1728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 14,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1085 3.20805L2.91357 14.5165L3.45625 15.1017L15.6512 3.79326L15.1085 3.20805Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8697 39.2965C50.0748 30.0914 50.0748 15.167 40.8697 5.9619C31.6646 -3.2432 16.7402 -3.2432 7.53511 5.9619C-1.66999 15.167 -1.66999 30.0914 7.53511 39.2965C16.7402 48.5016 31.6646 48.5016 40.8697 39.2965Z",
    fill: "#FFE89B"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0962 11.0962C13.6346 8.55779 13.6346 4.44221 11.0962 1.90381C8.55779 -0.634602 4.44222 -0.634602 1.90381 1.90381C-0.634597 4.44221 -0.634597 8.55779 1.90381 11.0962C4.44222 13.6346 8.55779 13.6346 11.0962 11.0962Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.885 1.09212L0.690186 12.4005L1.79551 13.5924L13.9903 2.28409L12.885 1.09212Z",
    fill: "#FFF09C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0962 11.0962C13.6346 8.55779 13.6346 4.44221 11.0962 1.90381C8.55779 -0.634602 4.44222 -0.634602 1.90381 1.90381C-0.634597 4.44221 -0.634597 8.55779 1.90381 11.0962C4.44222 13.6346 8.55779 13.6346 11.0962 11.0962Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2_1728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 14,
    height: 13
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.885 1.09212L0.690186 12.4005L1.79551 13.5924L13.9903 2.28409L12.885 1.09212Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8697 39.2965C50.0748 30.0914 50.0748 15.167 40.8697 5.9619C31.6646 -3.2432 16.7401 -3.2432 7.53505 5.9619C-1.67005 15.167 -1.67005 30.0914 7.53505 39.2965C16.7402 48.5016 31.6646 48.5016 40.8697 39.2965Z",
    fill: "#FFE89B"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0962 11.0962C13.6346 8.55779 13.6346 4.44221 11.0962 1.90381C8.55779 -0.634602 4.44222 -0.634602 1.90381 1.90381C-0.634597 4.44221 -0.634597 8.55779 1.90381 11.0962C4.44222 13.6346 8.55779 13.6346 11.0962 11.0962Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6448 0.00099365L-0.550049 11.3093L0.198312 12.1164L12.3931 0.808019L11.6448 0.00099365Z",
    fill: "#FFF09C"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 11.7001C9.37194 11.7001 11.7001 9.37194 11.7001 6.50001C11.7001 3.62809 9.37194 1.29993 6.50001 1.29993C3.62809 1.29993 1.29993 3.62809 1.29993 6.50001C1.29993 9.37194 3.62809 11.7001 6.50001 11.7001Z",
    fill: "#EB9F06"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 11,
    height: 11
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 11.7001C9.37194 11.7001 11.7001 9.37194 11.7001 6.50001C11.7001 3.62809 9.37194 1.29993 6.50001 1.29993C3.62809 1.29993 1.29993 3.62809 1.29993 6.50001C1.29993 9.37194 3.62809 11.7001 6.50001 11.7001Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8697 39.2965C50.0748 30.0914 50.0748 15.167 40.8697 5.9619C31.6646 -3.2432 16.7401 -3.2432 7.53505 5.9619C-1.67005 15.167 -1.67005 30.0914 7.53505 39.2965C16.7402 48.5016 31.6646 48.5016 40.8697 39.2965Z",
    fill: "#E49D0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65445 11.7861C9.49042 11.7861 11.7894 9.48713 11.7894 6.65116C11.7894 3.81518 9.49042 1.51617 6.65445 1.51617C3.81848 1.51617 1.51947 3.81518 1.51947 6.65116C1.51947 9.48713 3.81848 11.7861 6.65445 11.7861Z",
    fill: "#FFD111"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 11,
    height: 11
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 11.7001C9.37194 11.7001 11.7001 9.37194 11.7001 6.50001C11.7001 3.62809 9.37194 1.29993 6.50001 1.29993C3.62809 1.29993 1.29993 3.62809 1.29993 6.50001C1.29993 9.37194 3.62809 11.7001 6.50001 11.7001Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2_1728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2_1728",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 11,
    height: 11
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65445 11.7862C9.49042 11.7862 11.7894 9.48719 11.7894 6.65122C11.7894 3.81525 9.49042 1.51624 6.65445 1.51624C3.81848 1.51624 1.51947 3.81525 1.51947 6.65122C1.51947 9.48719 3.81848 11.7862 6.65445 11.7862Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8697 39.2966C50.0748 30.0915 50.0748 15.1671 40.8697 5.96196C31.6646 -3.24314 16.7401 -3.24314 7.53505 5.96196C-1.67005 15.1671 -1.67005 30.0915 7.53505 39.2966C16.7402 48.5017 31.6646 48.5017 40.8697 39.2966Z",
    fill: "#FFC402"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.947f457f3235cc809743730a2e05d3b9.svg";
export { ForwardRef as ReactComponent };